import { createSlice } from "@reduxjs/toolkit";
import { set } from "react-hook-form";

const userSlice = createSlice({
  name: "user",
  initialState: {
    loginUser: null,
    isAuthenticated: false,
    userToken: null,


  },
  reducers: {
    setLoginUser: (state, action) => {
      return { ...state, loginUser: action.payload , isAuthenticated: !!action.payload };
    },
    logoutUser: (state) => {
      state.loginUser = null;
      state.isAuthenticated = false;
      state.userToken = null;

    },
    setIsAuthenticated: (state, action) => {
      state.isAuthenticated = action.payload;
    },
    setUserToken: (state, action) => {
      state.userToken = action.payload;
    }

  },
});

export const { setLoginUser, logoutUser, setIsAuthenticated, setUserToken } = userSlice.actions;


export default userSlice.reducer;